import { UiApiGetClientBaseV1 } from './get-client-base'

export abstract class UiApiCrudClientBaseV1<
  Item extends { uid: string },
> extends UiApiGetClientBaseV1<Item> {
  protected async mergeAndPut(
    basePath: string,
    item: Partial<Item> & { uid: string },
  ): Promise<Item> {
    const current = await this.get({ uid: item.uid })
    const merged = { ...current, ...item }
    return this.restPut<Item>(`${basePath}/${item.uid}`, merged)
  }

  public abstract getItem(response: Item): Item
  public abstract create(request: unknown): Promise<Item>
  public abstract put(request: unknown): Promise<Item>
  public abstract del(request: unknown): Promise<unknown>
  public abstract getMany(request: unknown): Promise<Item[]>
}
